/**
 * Returns the occupation as text for a given origo coce.
 * Will return null if the code is unknown.
 * @param {string} origocode 
 *  Origo code to look up.
 *
 * @returns {string}
 *  The human friendly origo occupation name.
 */
export function origoCodeToOccupation(origoCode) {
  if(!origoList.hasOwnProperty(origoCode)) {
    return(null);
  }
  return(origoList[origoCode]);
}

export const origoList = {
  "": "--- Please Select ---",
  AAB00001: "Abattoir Inspector",
  AAC02588: "Abattoir Worker",
  AAD03000: "Abrasive Wheels Worker",
  AAB00010: "Account Executive",
  AAB00144: "Account Manager",
  AAB00011: "Accountant",
  AAD03393: "Accounts Administrator or Assistant",
  AAB00013: "Acidifier Operator",
  AAD03002: "Acrobat",
  AAB00130: "Actor or Actress - No Stunt Work",
  AAB00021: "Actuary",
  AAB00022: "Acupuncturist",
  AAC02590: "Administration Manager",
  AAC02607: "Advanced Nurse Practitioner",
  AAC02616: "Advertising Executive",
  AAB00023: "Advertising Manager",
  AAB00131: "Aerial Erector - Including Above 40 Feet",
  AAB00132: "Aerial Erector - Never Above 40 Feet",
  AAB00026: "Aerial Photography",
  AAC02592: "Aerobics Instructor",
  AAC02608: "Agile Coach",
  AAB00028: "Agricultural Engineer",
  AAB00030: "Agricultural Worker",
  AAB00031: "Agronomist",
  AAB00145: "Air Ambulance Crew",
  AAD03004: "Air Compressor Operator",
  AAC02609: "Air Conditioning Engineer",
  AAC02610: "Air Conditioning Engineer's Mate",
  AAB00036: "Air Frame Service Fitter",
  AAB00133: "Air Pump Attendant - Coastal",
  AAB00134: "Air Pump Attendant - Deep Sea",
  AAB00039: "Air Traffic Control Assistant",
  AAB00041: "Air Traffic Controller",
  AAC02593: "Air Traffic Planner",
  AAB00042: "Aircraft Electronics Service Fitter",
  AAB00043: "Aircraft Engine Service Fitter",
  AAB00044: "Aircraft Finisher",
  AAB00045: "Aircraft Inspector",
  AAB00047: "Aircraft Joiner",
  AAB00048: "Aircraft Maintenance Technician",
  AAB00049: "Aircraft Marshaller",
  AAB00050: "Aircraft Refueller",
  AAB00136: "Aircrew - Including Flight Engineer",
  AAB00052: "Airline Cabin Staff",
  AAB00137: "Airline Pilot",
  AAC02611: "Airport Check - In Clerk",
  AAB00054: "Airport Manager",
  AAB00055: "Airport Superintendent",
  AAC02612: "Alarm Fitter or Engineer",
  AAC02613: "Allergist",
  AAC02614: "Alternative Therapist",
  AAC02594: "Ambassador",
  AAB00138: "Ambulance Crew - No Driving",
  AAB00057: "Ambulance Driver",
  AAB00119: "Amusement Arcade Worker",
  AAD03005: "Amusement Park Worker",
  AAB00060: "Anaesthetist",
  AAD03008: "Analyst - Investment",
  AAD03395: "Analyst - Other",
  AAD03009: "Analyst - Systems",
  AAC02596: "Analytical Chemist",
  AAB00062: "Ancient Monuments Inspector",
  AAB00146: "Animal Groomer or Beautician",
  AAB00063: "Animal Nursing Auxiliary",
  AAB00139: "Animal Trainer or Keeper",
  AAB00147: "Animal Warden",
  RAB02065: "Animal Welfare Officer",
  AAB00065: "Animator",
  AAB00066: "Annealer",
  AAB00140: "Announcer - Radio and TV - Entertainment",
  AAB00068: "Announcer - Station Personnel - Railways",
  AAB00069: "Anodiser",
  AAB00070: "Antique Dealer",
  AAB00071: "Antique Restorer",
  AAD03408: "App Designer",
  AAD03409: "App Developer",
  AAB00073: "Arc Welder",
  AAB00074: "Archaeologist",
  AAB00075: "Architect",
  AAC02604: "Architect - Office",
  AAC02615: "Architectural Technologist",
  AAB00076: "Archivist",
  AAD03396: "Armed Forces - Army (Aircrew)",
  AAD03397: "Armed Forces - Army (Bomb Disposal)",
  AAD03398: "Armed Forces - Army (No Bomb Disposal)",
  AAD03399: "Armed Forces - Army (SAS)",
  AAD03400: "Armed Forces - Full Time Reservist (No Special Duties)",
  AAD03401: "Armed Forces - Full Time Reservist (Special Duties)",
  AAD03402: "Armed Forces - Navy (Aircrew)",
  AAD03407: "Armed Forces - Navy (Diving)",
  AAD03403: "Armed Forces - Navy (No Diving)",
  AAD03404: "Armed Forces - Navy (SBS)",
  AAD03406: "Armed Forces - RAF (Aircrew)",
  AAD03405: "Armed Forces - RAF (No Flying)",
  AAB00079: "Aromatherapist",
  AAB00081: "Art Director",
  AAB00082: "Art Gallery Attendant",
  AAB00083: "Art Gallery Curator",
  AAB00084: "Art Gallery Guide",
  AAC02599: "Art Gallery Manager - Commercial",
  AAB00085: "Artexer",
  AAD03410: "Artificial Intelligence Developer or Specialist",
  AAB00086: "Artist - Freelance Painter",
  AAB00087: "Artist Commercial",
  AAD03021: "Asbestos Inspector",
  AAB00089: "Asbestos Worker",
  AAB00095: "Asphalter",
  AAB00108: "Assembler - Woodworking Industry",
  AAB00109: "Assembly Inspector",
  AAC02605: "Assessor - Insurance Claims",
  AAB00110: "Assistant Cameraman",
  AAB00111: "Assistant Director",
  AAB00112: "Assistant Editor",
  AAB00113: "Assistant Superintendent",
  AAB00149: "Assistant Toolpusher",
  AAB00115: "Associate Producer",
  AAC02606: "Assumed Non-Hazardous - For Quotation only",
  AAB00116: "Astrologer",
  AAB00117: "Astronomer",
  AAC02602: "Atomic Energy Worker",
  AAB00142: "Attendant - Bingo (Entertainment)",
  AAB00143: "Attendant - Fairground or Entertainment",
  AAD03022: "Au Pair",
  AAB00122: "Auctioneer",
  AAB00148: "Audiologist",
  AAB00123: "Audiometrician",
  AAB00124: "Auditor",
  AAB00125: "Author",
  AAB00126: "Autoclave Operator",
  AAB00127: "Autolysis Man",
  AAB00128: "Automatic Train Attendant",
  AAD03023: "Auxiliary Nurse",
  BAB00130: "Baggage Handler",
  BAD03025: "Baggage Manager",
  BAB00133: "Baggage Master",
  BAB00134: "Baggage Porter",
  BAD03026: "Bailiff",
  BAC02606: "Baker",
  BAB00135: "Bakery Equipment Operator",
  BAC02607: "Bakery Shop Manager",
  BAB00137: "Baler",
  BAD03393: "Ballet Dancer",
  BAD03394: "Ballet Teacher",
  BAB00138: "Band Leader",
  BAB00139: "Band Mill Sawyer",
  BAB00141: "Bank Staff",
  BAD03027: "Banksman",
  BAB00152: "Banksman's Assistant",
  BAC02629: "Bar Manager or Proprietor",
  BAB00259: "Bar Staff",
  BAC02610: "Barber",
  BAC02630: "Barber - Shop Manager or Proprietor",
  BAB00154: "Bargeman - Merchant Marine",
  BAB00155: "Bargeman - Quarrying",
  BAB00156: "Bargemaster",
  BAB00278: "Barista",
  BAB00157: "Barley Roaster",
  BAB00160: "Barrelman",
  BAC02612: "Barrister",
  BAB00287: "Barrister; Advocate",
  BAB00279: "Bartender",
  BAB00280: "Bathroom Installer",
  BAB00164: "Battery Assembler",
  BAB00165: "Battery Repairer",
  BAB00167: "Beautician",
  BAC02631: "Beautician Shop Manager or Proprietor",
  BAC02635: "Beauty Therapist",
  BAC02632: "Bed and Breakfast Proprietor",
  BAB00288: "Beekeeper; Apiarist",
  BAB00169: "Belt Maker",
  BAB00170: "Belt Patrol Man",
  BAB00260: "Bench Hand - Production Fitting (Metal Manufacture)",
  BAB00261: "Bench Hand - Rubber Industry (Natural)",
  BAB00281: "Benefits Adviser",
  BAB00173: "Berthing Superintendent",
  BAC02633: "Betting Shop Manager - On Course",
  BAC02634: "Betting Shop Manager - Shop Based",
  BAD03395: "Bicycle Delivery Rider",
  BAB00262: "Billboard Poster or Sticker",
  BAB00176: "Bindery Assistant",
  BAB00177: "Binding Machine Attendant",
  BAD03996: "Bingo Hall Attendant",
  BAD03997: "Bingo Hall Caller",
  BAD03030: "Bingo Hall Manager",
  BAC02618: "Biochemist",
  BAC02636: "Biochemist - Lecturing and Research",
  BAC02637: "Biological Scientist",
  BAB00264: "Biologist - Overseas Travel",
  BAB00263: "Biologist - UK only (Some Underwater Work)",
  BAB00265: "Biologist - Underwater Work",
  BAB00283: "Biomedical Engineer",
  BAB00181: "Biscuit Baker",
  BAB00182: "Blacksmith",
  BAB00183: "Blancher",
  BAD04003: "Blaster - Quarry",
  BAB00266: "Bleacher - Paper and Board Manufacture",
  BAB00267: "Bleacher - Textile and Clothing Industry",
  BAB00186: "Blender",
  BAB00187: "Block Cutter",
  BAD03998: "Blogger",
  BAB00188: "Boarding School Matron",
  BAB00189: "Boat Builder",
  BAB00190: "Boatswain - Fishing Industry",
  BAB00191: "Boatswain - Merchant Marine",
  BAB00192: "Boatswain's Mate",
  BAD03999: "Body Piercer",
  BAB00193: "Bodyguard",
  BAB00268: "Boiler - Food and Drink",
  BAB00197: "Boiler Cleaner",
  BAB00198: "Boiler Operator - Electrical Supply",
  BAB00199: "Boiler Operator - Water Supply Industry",
  BAB00269: "Boiler Operator or Fireman",
  BAB00270: "Bomb Disposal",
  BAB00203: "Book Illustrator",
  BAD03032: "Book Seller",
  BAB00205: "Bookbinder",
  BAB00271: "Bookkeeper",
  BAB02089: "Bookmaker - On Course",
  BAB00207: "Bookmaker - Shop Manager",
  BAB00208: "Bookmaker - Shop Owner",
  BAB00209: "Bookmaker - Shop Staff",
  BAB00210: "Boom Operator",
  BAB00284: "Border Force Officer",
  BAB00212: "Borer - Mining",
  BAB00211: "Borer - Tunnelling",
  BAB00213: "Borstal Matron",
  BAB00272: "Bosun - Third Hand",
  BAB00273: "Botanist - No Overseas Field Work",
  BAB00274: "Bottle Washer - Hand or Machine",
  BAB00217: "Bottling Machine Attendant",
  BAB00218: "Box Maker",
  BAD03033: "Box Office Cashier",
  BAD03034: "Box Office Clerk",
  BAB00224: "Box Office Manager",
  BAB00226: "Brakesman",
  BAB00285: "Brand Manager",
  BAB00227: "Brazer",
  BAB00228: "Bread Baker",
  BAD03390: "Breakdown Recovery Worker",
  BAB00230: "Brewer",
  BAB00231: "Brewery Manager",
  BAB00232: "Bricklayer",
  BAB00275: "Bridgeman",
  BAD03036: "Briner",
  BAD03392: "Broker - Money or Investments",
  BAD03388: "Broker - Oil",
  BAD03040: "Broker - Other",
  BAB00236: "Bronzer",
  BAB00276: "Broom or Brush Maker",
  BAB00238: "Buffet Car Attendant",
  BAC02621: "Builder",
  BAB00239: "Building Inspector",
  BAC02638: "Building Site Agent - Building and Construction",
  BAD03041: "Building Society Worker",
  BAB00241: "Building Surveyor",
  BAB00243: "Bulldozer Driver",
  BAD04004: "Bunker Control Man",
  BAC02625: "Burglar Alarm Fitter",
  BAB00277: "Bus Conductor - No Driving",
  BAB00251: "Bus Driver",
  BAB00252: "Bus Inspector",
  AAD03394: "Business Analyst",
  BAB00286: "Business Behaviourist",
  BAB00253: "Business Consultant",
  BAD04000: "Business Development Manager",
  BAD04001: "Business Intelligence Analyst",
  BAD04002: "Business Intelligence Developer",
  BAB00255: "Butcher",
  BAC02627: "Butcher Shop Proprietor",
  BAB00256: "Butler",
  BAB00257: "Butter Blender",
  BAB00258: "Butter Maker",
  BAC02639: "Buyer - Retail",
  BAD04005: "Buyer - Stocks and Shares",
  CAB00259: "Cabin Boy",
  CAB00260: "Cabinet Maker",
  CAB00261: "Cable Former",
  CAB00262: "Cable Hand",
  CAB00263: "Cable Jointer",
  CAB00264: "Cable Laying Diver",
  CAB00265: "Cable Tester",
  CAD03997: "CAD Designer",
  CAD03998: "CAD Technician",
  CAB00266: "Cafe Cashier",
  CAC02629: "Cafe Manager",
  CAB00581: "Cafe Proprietor - Licensed",
  CAB00582: "Cafe Proprietor - Unlicensed",
  CAD03992: "Cafe Worker",
  CAD03999: "Cake Decorator",
  CAB00270: "Calibrator",
  CAD03047: "Call Centre Manager",
  CAD03048: "Call Centre Worker",
  CAB00271: "Caller",
  CAC02630: "Calligrapher",
  CAC02631: "Camera Repair Technician",
  CAD03049: "Cameraman Outside Work",
  CAB00273: "Cameraman Studio",
  CAD04024: "Cameraman War or Disaster Reporting",
  CAB00275: "Candle Maker",
  CAB00276: "Canine Beautician",
  CAC02632: "Canine Behaviourist",
  CAB00277: "Canning Machine Attendant",
  CAB00278: "Canteen Assistant",
  CAB00279: "Canteen Manager",
  CAB00280: "Canvasser",
  CAB00282: "Captain - Merchant Marine",
  CAB00583: "Captain - Oil and Natural Gas Industries",
  CAB00284: "Car Delivery Driver",
  CAC02702: "Car Hire Company Proprietor - Admin and Driving",
  CAB00285: "Car Lasher",
  CAB00286: "Car Park Attendant",
  CAC02634: "Car Rental Company Manager",
  CAD03051: "Car Rental Company Worker",
  CAB00584: "Car Salesperson",
  CAB00289: "Car Valeter",
  CAB00306: "Car Wash Attendant",
  CAD03052: "Caravan Site Manager",
  CAD03053: "Caravan Site Staff",
  CAB00290: "Carbon Printer",
  CAB00291: "Carbonation Man",
  CAB00292: "Carboniser",
  CAD04000: "Cardiac Surgeon",
  CAB00293: "Care Assistant",
  CAC02723: "Care Co-ordinator",
  CAC02724: "Care Home Manager",
  OAB01645: "Care Home Matron",
  OAB01646: "Care Home Warden",
  CAC02635: "Care Worker - Residential",
  CAC02725: "Career Coach",
  CAC02636: "Careers Advisor",
  CAC02726: "Carer",
  CAB00610: "Caretaker; Janitor",
  CAB00295: "Cargo Clerk",
  CAB00296: "Cargo Superintendent",
  CAB00608: "Carpenter",
  CAC02637: "Carpet Cleaner",
  CAC02703: "Carpet Company Director - Office Based Admin only",
  CAC02639: "Carpet Designer",
  CAB00300: "Carpet Fitter",
  CAC02705: "Carpet Sales Adviser",
  CAC02642: "Carpet Shop Assistant",
  CAC02706: "Carpet Shop Manager - Admin only",
  CAC02707: "Carpet Shop Owner - No Manual Duties",
  CAB00302: "Carriage Cleaner",
  CAB00301: "Carriage Examiner",
  CAB00303: "Cartographer",
  CAB00304: "Cartoonist",
  CAB00305: "Cartridge Filler",
  CAC02738: "Cashier - Bank; Building Society",
  CAC02739: "Cashier - Shop; Cafe; Supermarket; Bingo",
  CAB00309: "Casino Cashier",
  CAB00311: "Casting Director",
  CAB00312: "Casting Machine Operator",
  CAC02708: "Caterer - Offshore or At Sea",
  CAC02648: "Catering Assistant",
  CAC02649: "Catering Manager",
  CAB00585: "Cathead Operator",
  CAD03054: "Caulker",
  CAD03993: "CC TV Installer/Maintenance - Including Above 40 Feet",
  CAD03994: "CC TV Installer/Maintenance - Never Above 40 Feet",
  CAD04001: "CCTV Operator",
  CAB00323: "Ceiling Fixer",
  CAD04002: "Celebrant",
  CAB00324: "Cell Tester",
  CAB00325: "Cementer",
  CAD03057: "Cemetery Worker",
  CAB00326: "Ceramicist",
  CAB00328: "Chain Maker",
  CAB00329: "Chair Maker",
  CAC02653: "Chambermaid - Housekeeper",
  CAD04003: "Change Manager",
  CAB00330: "Charge Nurse",
  CAD04023: "Charity Worker - Admin only",
  CAD03391: "Charity Worker - Overseas Work",
  CAD03390: "Charity Worker - UK Work",
  CAC02727: "Chartered Architectural Technologist",
  CAC02737: "Chartered Engineer - Admin only",
  CAC02709: "Chartered Engineer - Some Site Duties",
  CAC02711: "Chartered Surveyor - Admin only",
  CAC02712: "Chartered Surveyor - Some Site Duties",
  CAB00332: "Chassis Builder",
  CAB00333: "Chauffeur",
  CAB00336: "Chef",
  CAB00611: "Chemical Engineer - Offshore",
  CAD04016: "Chemical Engineer - UK",
  CAB00344: "Chemical Plumber",
  CAB00345: "Chemical Plumber's Mate",
  CAD04017: "Chemist - Industrial",
  CAD04018: "Chemist - Retail",
  CAD04004: "Chief Executive Officer (CEO)",
  CAC02728: "Child Care Worker",
  CAC02729: "Child Maintenance Service Worker",
  CAC02658: "Child Protection Co-ordinator",
  CAD03995: "Child Support Worker",
  CAC02659: "Child Welfare Officer",
  CAB00368: "Childminder",
  CAB00370: "Children's Inspector",
  CAB00371: "Children's Matron",
  CAC02660: "Children's Nursery Proprietor",
  CAC02661: "Children's Play-group Leader",
  CAB00372: "Chimney Sweep",
  CAB00586: "Chip or Money Changer",
  CAC02662: "Chip Shop Owner",
  CAD03063: "Chip Shop Worker",
  CAB00588: "Chipper - Hand",
  CAB00587: "Chipper and Painter",
  CAB00376: "Chipping Driver",
  CAB00377: "Chiropodist",
  CAB00589: "Chiropractor",
  CAC02664: "Church Organist",
  CAD03064: "Cinema Projectionist",
  CAD04005: "Cinema Worker",
  CAB00383: "Circus Hand",
  CAD03065: "Circus Manager",
  CAD03066: "Civil Engineer",
  CAD03067: "Civil Servant",
  CAB00390: "Claims Adjuster",
  CAB00391: "Claims Assessor",
  CAD04006: "Classical Musician",
  CAC02730: "Classroom Assistant",
  CAD04019: "Cleaner - Commercial Premises",
  CAC02740: "Cleaner - Domestic Premises",
  CAD04022: "Cleaner - Industrial",
  CAB00405: "Clergy",
  CAB00406: "Clerical Staff",
  CAB00407: "Clerical Worker",
  CAB00409: "Clerk of Works",
  CAD04007: "Climate Scientist",
  CAC02731: "Clinical Manager",
  CAC02732: "Clinical Psychologist",
  CAD04008: "Clinical Scientist",
  CAB00590: "Cloakroom Attendant - Club or Nightclub - Entertainment",
  CAB00591: "Cloakroom Attendant - Theatre; Ballet - Entertainment",
  CAB00592: "Clock and Watch Assembler",
  CAB00593: "Clock or Watch Maker",
  CAB00594: "Clock or Watch Repairer",
  CAB00417: "Cloth Cutter",
  CAC02671: "Clothing Designer",
  CAD04009: "Cloud Computing Manager",
  CAB00418: "Clown",
  CAB00419: "Club Manager",
  CAB00420: "Club Proprietor",
  CAB00421: "Club Steward",
  CAB00427: "Coach Driver",
  CAB00428: "Coach Painter",
  CAB00431: "Coal Cutter Mover",
  CAB00432: "Coal Cutterman",
  CAB00433: "Coal Dry Cleaning Plant Operator",
  CAB00595: "Coal Face Worker",
  CAB00435: "Coal Melter",
  CAB00612: "Coal Merchant - Admin only",
  CAB00613: "Coal Merchant - Some Delivery",
  CAB00438: "Coal Trimmer",
  CAB00439: "Coal Washery Operator",
  CAB00440: "Coal Yard Foreman",
  CAB00441: "Coal Yard Man",
  CAB00596: "Coastguard - Office Based",
  CAB00597: "Coastguard - Otherwise",
  CAB00444: "Coffin Maker",
  CAD04010: "Cognitive Behavioural Therapist",
  CAB00445: "Coil Former",
  CAB00446: "Coil Winder",
  CAB00447: "College Lecturer",
  CAB00449: "Colour Calculator",
  CAB00450: "Colour Matcher",
  CAB00451: "Colour Mixer",
  CAB00452: "Columnist",
  CAB00453: "Comedian",
  CAB00599: "Commentator - Overseas Travel",
  CAB00598: "Commentator - UK only",
  CAB00456: "Commercial Diving",
  CAC02713: "Commercial Manager - Office Sales",
  CAB00600: "Commercial Pilot",
  CAC02675: "Commercial Traveller",
  CAB00458: "Commissionaire",
  CAD04011: "Communications Manager",
  CAD03071: "Community Development Worker",
  CAB00460: "Community Nurse",
  CAC02714: "Company Director - Admin Duties only",
  CAC02679: "Company Secretary",
  CAB00462: "Compass Adjuster",
  CAC02680: "Compliance Manager",
  CAC02733: "Complimentary Therapist",
  CAB00463: "Composer",
  CAB00464: "Compositor",
  CAB00465: "Compounder",
  CAD04012: "Computer Graphics Artist",
  CAC02690: "Concert Promoter",
  CAB00601: "Concrete Erector - Including Above 40 Feet",
  CAB00602: "Concrete Erector - Never Above 40 Feet",
  CAB00470: "Concrete Finisher",
  CAB00471: "Concrete Paving Driver",
  CAB00472: "Concrete Shutterer",
  CAB00473: "Concreter",
  CAB00603: "Conductor - Music Industry (Entertainment)",
  CAB00604: "Conductor - Train Crew (Railways)",
  CAC02691: "Confectioner",
  CAC02692: "Conference Organising Assistant",
  CAC02693: "Conference Organising Manager",
  CAB00609: "Construction Site Manager",
  CAB00605: "Construction Worker",
  CAC02734: "Consultant Psychiatrist",
  CAC02735: "Consultant Surgeon",
  CAB00480: "Contact Lens Technician",
  CAB00481: "Continuity Clerk",
  CAD04013: "Contracts Manager",
  CAB00482: "Control Engineer",
  CAD03072: "Control Room Operator",
  CAD03073: "Conveyancer",
  CAD03074: "Conveyer Operator",
  CAB00508: "Cook",
  CAB00514: "Cooper",
  CAB00515: "Coppersmith",
  CAB00516: "Copyholder",
  CAB00606: "Copyholder - Newspapers",
  CAB00518: "Copytaster",
  CAC02695: "Copywriter",
  CAB00519: "Core Borer",
  CAB00520: "Core Builder",
  CAB00521: "Coremaker",
  CAB00522: "Coroner",
  CAB00527: "Costermonger",
  CAB00528: "Costume Designer",
  CAC02696: "Costumier",
  CAC02736: "Counselling Psychologist",
  CAB00529: "Counsellor",
  CAB00530: "Counter Staff - Dry Cleaning",
  CAB00531: "Counter Staff - Laundry",
  CAB00607: "Counter Staff - Post Office or Telecommunications",
  CAC02721: "Courier",
  CAB00533: "Court Bailiff",
  CAB00534: "Court Usher",
  CAB00535: "Crab Fisherman",
  CAB00542: "Crane Erector",
  CAD03075: "Crane Operator",
  CAD03076: "Crane Slinger",
  CAC02698: "Credit Agent",
  CAC02699: "Credit Controller",
  CAD04014: "Crime Scene Officer",
  CAB00559: "Critic",
  CAD04020: "Crop Sprayer - On Ground",
  CAD04021: "Crop Sprayer - Pilot",
  CAB00562: "Crossing Keeper",
  CAB00563: "Croupier",
  CAB00566: "Crushing Worker",
  CAC02722: "Curator - Museum",
  CAB00567: "Curator - Zoo",
  CAB00568: "Curer",
  CAC02701: "Customer Care Officer",
  CAD03079: "Customer Service Staff",
  CAD03996: "Customs and Excise Officer",
  CAD03082: "Cutting Machine Operator",
  CAD04015: "Cyber Security Expert",
  DAC02728: "Dairy Worker",
  DAC02729: "Dance Teacher",
  DAB00582: "Dancer",
  DAD03394: "Data Analyst",
  DAD03084: "Data Controller",
  DAD03085: "Data Inputter",
  DAD03395: "Data Scientist",
  DAB00585: "Debt Collector",
  DAB00719: "Debt Recoverer - Admin only",
  DAB00586: "Deck Chair Attendant",
  DAB00587: "Deck Hand",
  DAB00589: "Deck Officer",
  DAB00593: "Delivery Driver",
  DAB00711: "Demolition Worker - No Explosives",
  DAB00725: "Demolition Worker - Using Explosives",
  DAB00598: "Dental Assistant",
  DAC02707: "Dental Auxiliary",
  DAB00599: "Dental Consultant",
  DAB00600: "Dental Hygienist",
  DAB00601: "Dental Nurse",
  DAB00602: "Dental Practitioner",
  DAD03088: "Dental Receptionist",
  DAB00603: "Dental Technician",
  DAB00604: "Dental Therapist",
  DAB00605: "Dentist",
  DAD03089: "Department Store Manager",
  DAD03401: "Department Store Worker",
  DAC02708: "Dermatologist",
  DAD03402: "Design Cutter",
  DAB00612: "Designer",
  DAB00616: "Detention Centre Warden",
  DAB00720: "Diagnostic Vehicle Technician",
  DAD03388: "Diamond Worker",
  DAB00626: "Die Cutter",
  DAB00627: "Die Setter",
  DAB00629: "Diesel Locomotive Fitter",
  DAC02709: "Dietician",
  DAD03396: "Digital Content Specialist",
  DAD03397: "Digital Marketing Specialist",
  DAB00631: "Dining Car Attendant",
  DAD03093: "Dinner Lady",
  DAD03408: "Director - Company - Admin only",
  DAD03391: "Director - Company - Some Manual Work",
  DAD03409: "Director - Managing - Admin only",
  DAD03400: "Director - Managing - Some Manual Work",
  DAD03379: "Director - Musical",
  DAD03410: "Director - Sales - Management only",
  DAD03411: "Director - Sales - Some Selling",
  DAD03399: "Director - Some Manual Work",
  FAC02808: "Director - TV and Film",
  DAC02730: "Director and Medical Consultant",
  DAB00637: "Disc Jockey",
  DAB00638: "Disinfecting Officer",
  DAC02711: "Dispatch Rider",
  DAB00640: "Dispatcher",
  DAC02712: "Distiller",
  DAB00641: "Distillery Manager",
  DAB00642: "District Nurse",
  DAC02713: "Diver",
  DAC02731: "Diver - North Sea",
  DAB00712: "Diver's Linesman - Coastal",
  DAB00713: "Diver's Linesman - Deep Sea",
  DAD03398: "Diversity and Inclusion Manager",
  DAB00647: "Dock Foreman",
  DAB00648: "Dock Master",
  DAB00649: "Dock Superintendent",
  DAB00650: "Docker",
  DAC02733: "Doctor - Health (Including Surgery)",
  DAB00714: "Doctor - Health (No Surgery)",
  DAC02734: "Doctor - Infectious Diseases",
  DAB00652: "Doctor - Merchant Marine",
  DAC02715: "Dog Catcher",
  DAC02735: "Dog Day-care Assistant",
  DAC02736: "Dog Day-care Owner",
  DAC02737: "Dog Groomer",
  DAC02738: "Dog Walker",
  DAB00656: "Domestic Electrician",
  DAB00657: "Domestic Premises Cleaner",
  DAB00715: "Domestic Supervisor - Hospital",
  DAC02716: "Domestic Tiler",
  DAB00659: "Donkeyman",
  DAD03389: "Door Supervisor",
  DAB00716: "Door to Door Sales Represenative",
  DAC02732: "Double Glazing - Installer or Fitter",
  DAC02719: "Double Glazing Surveyor",
  DAD03390: "Drainage Layer or Clearer",
  DAB00721: "Drainage Surveyor",
  DAC02720: "Draper",
  DAB00665: "Draughtsman",
  DAB00717: "Drawer - Bar; Plate; Rod",
  DAB00667: "Drayman",
  DAB00668: "Dredger Driver",
  DAB00669: "Dredgerman",
  DAB00672: "Dresser",
  DAB00673: "Dressmaker",
  DAD03403: "Driller - Offshore",
  DAD03404: "Driller - Onshore",
  DAD03405: "Driver - Construction",
  DAD03406: "Driver - Delivery",
  DAD03101: "Driver - HGV",
  DAD03407: "Driver - Industrial Plant",
  DAD03103: "Driver - PSV",
  DAC02739: "Driver - Refuse",
  DAC02740: "Driver - Tractor",
  DAB00699: "Driving Examiner",
  DAB00700: "Driving Instructor",
  DAB00722: "Driving Instructor HGV",
  DAB00723: "Drone Pilot",
  DAB00701: "Drop Ball Operator",
  DAB00702: "Dry Cleaning Machine Operator",
  DAB00724: "Dry Liner",
  DAB00703: "Dry Salter",
  DAB00718: "Dustman or Refuse Collector",
  DAB00710: "Dyer",
  EAD03126: "Ecological Consultant",
  EAD03129: "Ecologist",
  EAB00712: "Economist",
  EAD03130: "Editor - No Overseas Travel",
  EAD03131: "Editor - Overseas Travel",
  EAD03107: "Editorial Assistant",
  EAD03108: "Education Assistant",
  EAC02729: "Educational Advisor",
  EAB00715: "Effluent Inspector",
  EAB00716: "Electric Logger",
  EAB00717: "Electrical Contractor",
  EAD03109: "Electrical Engineer",
  EAB00722: "Electrical Fitter",
  EAB00724: "Electrical Wireman",
  EAD03133: "Electrician - Offshore",
  EAD03134: "Electrician UK Based - Domestic",
  EAD03135: "Electrician UK Based - Industrial",
  EAB00736: "Electronics Fitter",
  EAB00737: "Electronics Installer",
  EAB00739: "Electronics Repairer",
  EAB00741: "Electronics Wireman",
  EAB00742: "Electroplater",
  EAB00743: "Electrotyper",
  EAB00744: "Embalmer",
  EAD03113: "Embassy Employee",
  EAB00745: "Embroiderer",
  EAC02756: "Emergency Medical Technician",
  EAD03127: "Employment Agency Administrator",
  EAC02755: "Employment Agency Owner - Admin only",
  EAB00746: "Enameller",
  EAB00747: "Engine Driver",
  EAB00748: "Engine Tester",
  EAD03136: "Engineer - Admin and Site Visits only",
  EAD03137: "Engineer - Admin only",
  EAD03138: "Engineer - Heavy Manual",
  EAD03128: "Engineer - Including Above 40 Feet",
  EAD03141: "Engineer - Light Manual",
  EAD03132: "Engineer - Never Above 40 Feet",
  EAC02759: "Engineer - Offshore",
  EAD03139: "Engineer - Sales",
  EAB00762: "Engineering Fitter",
  EAB00764: "Engineering Technician",
  EAD03122: "Engraver",
  EAB00770: "Enrolled Nurse",
  EAC02760: "Entertainer - Entertainment Industry",
  EAC02761: "Entertainment Agent - Entertainment Industry",
  EAC02762: "Entertainment Manager - Entertainment Industry",
  EAB00771: "Entertainments Officer",
  EAC02749: "Environmental Health Officer",
  EAC02757: "Environmentalist",
  EAC02758: "Epidemiologist",
  EAB00772: "Equestrian Artiste",
  EAB00773: "Equestrianism - Riding Instructor",
  EAB00774: "Equestrianism - Show Jumping",
  EAB00775: "Equipment Cleaner",
  EAB00803: "Erector - Aircraft or Aerospace",
  EAB00804: "Erector - Production Fitting (Metal Manufacture)",
  EAB00778: "Escapologist",
  EAB00779: "Estate Agent",
  EAC02763: "Estate Manager - All Aspects (No Manual Work)",
  EAB00780: "Estate Ranger",
  EAB00806: "Etcher - Creative",
  EAB00783: "Etcher - Pottery Industry",
  EAB00805: "Etcher - Precious Metals; Engraving - Metal Manufacture",
  EAB00784: "Etcher - Printing Industry",
  EAB00807: "Ethical Sourcing Officer",
  EAB00808: "Event Organiser",
  EAB00809: "Event Promoter",
  EAB00810: "Events Manager",
  EAD03140: "Examiner - Process",
  EAB00795: "Excavator Driver",
  EAD03125: "Exhaust Fitter",
  EAB00796: "Exhausterman",
  EAB00811: "Exhibition Erector",
  EAC02752: "Exhibition Foreman",
  EAB00812: "Exhibition Organiser",
  EAC02753: "Exhibition Space Sales Manager",
  EAB00797: "Exhibition Stand Fitter",
  EAB00798: "Explosives Inspector",
  EAC02754: "Export Agent",
  EAB00800: "Extruder",
  FAD03126: "Fabric Designer",
  FAD03144: "Fabricator - Welder or Fitter",
  FAD03128: "Facilities Assistant",
  FAD03146: "Facilities Manager",
  FAB00803: "Facilities Procurement Officer",
  FAB00806: "Factory Inspector",
  FAC02798: "Factory Manager - Mainly Admin",
  FAC02797: "Factory Worker",
  FAC02757: "Fairground Worker",
  FAC02799: "Farm Manager - Manual Duties",
  FAC02800: "Farm Manager - No Manual Duties",
  FAC02801: "Farm Owner - Manual Duties",
  FAC02802: "Farm Owner - No Manual Duties",
  FAC02803: "Farm Worker or Labourer",
  FAC02805: "Farmer",
  FAB00811: "Farrier",
  FAB00813: "Fashion Photographer",
  FAD03129: "Fashion Stylist",
  FAD03130: "Fast Food Restaurant Assistant",
  FAC02804: "Fast Food Restaurant Manager - Admin only",
  FAB00814: "Fat Extractor Man",
  FAC02768: "Fencing Contractor",
  FAB00816: "Ferryman",
  FAB00969: "Fibreglass Worker",
  FAB00821: "Fight Arranger",
  FAB00823: "Film Developer",
  FAB00824: "Film Joiner",
  FAB00825: "Film Processor",
  FAB00827: "Filmsetting Machine Operator",
  FAD03147: "Finance Director",
  FAC02774: "Financial Adviser",
  FAD03148: "Financial Controller",
  FAD03145: "Financial Planner or Paraplanner",
  FAD03149: "Finisher - Toys and Textiles",
  FAB00832: "Fire Eater",
  FAB00833: "Fire Prevention Officer",
  FAB00835: "Firefighter - Fire Service",
  FAD03150: "Fish and Chip Shop Owner",
  FAD03151: "Fish and Chip Shop Worker",
  FAB00843: "Fish Farmer",
  FAB00848: "Fish Preparer",
  FAB00849: "Fisherman",
  FAB00964: "Fishery Officer or Warden",
  FAC02779: "Fishmonger",
  FAC02810: "Fitness Instructor",
  FAB00966: "Fitter - Assembler",
  FAB00965: "Fitter - Motor Vehicle and Cycle Industry",
  FAB00858: "Fixer Mason",
  FAB00967: "Flame Cutter - Including Above 40 Feet",
  FAB00968: "Flame Cutter - Never Above 40 Feet",
  FAD03135: "Flight Attendant",
  FAB00867: "Flight Dispatcher",
  FAD03138: "Flight Operations Manager",
  FAB00869: "Flight Planner",
  FAB00870: "Floor Layer",
  FAB00871: "Floor Manager",
  FAB00872: "Floor Tiler",
  FAB00873: "Floorman",
  FAC02807: "Floorman - Oil and Natural Gas Industries",
  FAC02786: "Florist",
  FAB00874: "Flour Confectioner",
  FAB00970: "Food Courier",
  FAB00971: "Food Process Worker",
  FAB00876: "Food Technologist",
  FAC02809: "Football Manager - Professional Players",
  FAC02788: "Forecourt Attendant",
  FAD03152: "Foreman - Heavy Manual",
  FAD03153: "Foreman - Light Manual",
  FAD03154: "Foreman - No Manual",
  FAD03155: "Foreman - Offshore",
  FAC02806: "Forensic Psychologist",
  FAB00937: "Forest Ranger",
  FAB00938: "Forest Worker",
  FAB00940: "Forestry Officer",
  FAB00941: "Forge Hammerman",
  FAB00942: "Forge Pressman",
  FAB00943: "Forger",
  FAB00944: "Fork Lift Truck Driver",
  FAB00945: "Fortune Teller",
  FAD03136: "Foster Parent",
  FAB00946: "Frame Finisher",
  FAB00972: "Fraud Investigator",
  FAB00947: "Freezer Operator",
  FAB00948: "Freight Clerk",
  FAB00949: "Freight Manager - Airport",
  FAB00950: "Freight Manager - Docks",
  FAB00951: "French Polisher",
  FAB00973: "Fruit Picker - Fruit",
  FAC02793: "Fruitier",
  FAB00952: "Fuel Technologist",
  FAB00974: "Fulfilment Centre Associate",
  FAB00953: "Funeral Director",
  FAB00954: "Funeral Director's Assistant",
  FAB00955: "Furnace Control Room Operator",
  FAB00975: "Furnace Operator - Cemetery; Crematorium",
  FAD03137: "Furnace Operator - Other",
  FAB00961: "Furniture Designer",
  FAC02794: "Furniture Maker",
  FAB00962: "Furniture Remover",
  FAC02795: "Furniture Restorer",
  FAC02796: "Furniture Retailer",
  GAD03150: "Gallery Assistant",
  GAC02817: "Gallery Owner - Admin only",
  GAC02819: "Gallery Owner - Including Manual Work",
  GAD03155: "Galley Hand",
  GAB00965: "Galvaniser",
  GAB00966: "Gamekeeper",
  GAB00968: "Ganger",
  GAD03156: "Gantry Crane Driver",
  GAC02801: "Garage - Petrol Pump Attendant",
  GAC02828: "Garage Proprietor - Admin only",
  GAC02821: "Garage Repair Shop Supervisor - Including Manual Duties",
  GAC02804: "Gardener",
  GAB00972: "Gas Compressor Operator",
  GAB00976: "Gas Fitter",
  GAB00979: "Gas Meter Tester",
  GAC02824: "Gastroenterologist",
  GAB00984: "Gem Cutter",
  GAB00985: "Gem Polisher",
  GAB00986: "Gem Setter",
  GAC02825: "General Practice Nurse",
  GAC02826: "Geneticist",
  GAB00987: "Geologist - Mining",
  GAB01029: "Geologist - No Aerial or Offshore",
  GAB01028: "Geologist - Oil and Natural Gas Industries",
  GAB00990: "Geophysicist - Mining",
  GAB01030: "Geophysicist - Oil and Natural Gas Industries",
  GAC02806: "Glass Blower",
  GAD03151: "Glass Worker",
  GAB00996: "Glazer",
  GAD03152: "Glazier",
  GAB01000: "Gold Beater",
  GAC02807: "Goldsmith",
  GAB01001: "Golf - Caddie",
  GAB01033: "Golf-Club Professional",
  GAB01003: "Governor",
  GAD03159: "GP - General Practitioner (Doctor)",
  GAB01004: "Grader",
  GAC02822: "Grain Merchant - Office Based",
  GAD03157: "Graphic Artist",
  GAC02809: "Graphic Designer",
  GAB01007: "Grave Digger",
  GAD03154: "Greaser",
  GAB01010: "Greenkeeper",
  GAD03144: "Grinder",
  GAC02813: "Grocer",
  GAB01019: "Groom",
  GAB01032: "Ground Hostess or Steward",
  GAB01022: "Ground Movement Controller",
  GAB01023: "Groundsman",
  GAD03147: "Groundworker",
  GAD03160: "Guard - Railway",
  GAD03161: "Guard - Security",
  GAC02815: "Guest House Proprietor",
  GAC02823: "Guest House Proprietor - Admin only",
  GAB01025: "Guillotine Operator",
  GAB01026: "Gummer",
  GAD03153: "Gunsmith",
  GAD03158: "Gym Instructor",
  GAC02827: "Gynaecologist",
  HAC02817: "Haberdasher",
  HAC02858: "Haematologist",
  HAB01028: "Hairdresser - Mobile",
  HAB01029: "Hairdresser - Salon",
  HAC02861: "Hairdresser Shop Manager - Admin only",
  HAC02819: "Hairdresser Shop Proprietor",
  HAD03164: "Hammerman",
  HAB01106: "Handyperson or Handyworker",
  HAB01038: "Harbour Master",
  HAC02820: "Harbour Pilot",
  HAD03157: "Hardware Shop Retailer",
  HAB01041: "Harness Maker",
  HAB01043: "Hat Maker",
  HAB01044: "Hatchery Worker",
  HAC02822: "Haulage Contractor",
  HAB01107: "Haulier - No Driving",
  HAB01047: "Head Gardener",
  HAB01108: "Head Groundskeeper",
  HAB01049: "Head Keeper - Zoo",
  HAB01050: "Head Roustabout",
  HAC02823: "Headteacher",
  HAC02844: "Health and Fitness Club Manager - Admin only",
  HAC02826: "Health and Fitness Club Trainer",
  HAC02853: "Health and Safety Consultant",
  HAC02843: "Health and Safety Officer",
  HAC02854: "Health Care Assistant",
  HAC02855: "Health Care Support Worker",
  HAC02827: "Health Counsellor",
  HAB01053: "Health Radiation Monitor",
  HAC02828: "Health Visitor",
  HAC02845: "Heating and Ventilation Engineer",
  HAC02831: "Helicopter Engineer",
  HAC02848: "Helicopter Pilot - Not Oil and Natural Gas Industries",
  HAC02847: "Helicopter Pilot - Oil and Natural Gas Industries",
  HAC02856: "Helpline Operator",
  HAB01111: "Herbalist",
  HAB01109: "HGV Driver",
  HAC02846: "HGV Driver (No Loading)",
  HAB01112: "Highway Maintenance Worker",
  HAC02857: "Histologist",
  HAD03389: "Historian",
  HAB01066: "Historic Building Guide",
  HAD03393: "Hod Carrier - Construction",
  HAB01067: "Hoist Driver",
  HAD03163: "Hoist Operator",
  HAD03165: "Holiday Representative",
  HAC02834: "Home Help",
  HAC02849: "Homeless Centre Manager - Admin only",
  HAC02836: "Homeopath",
  HAB01076: "Horse Breeder",
  HAB01077: "Horse Racing - Flat Jockey",
  HAB01114: "Horse Racing - National Hunt Jockey",
  HAC02837: "Horticulturist",
  HAC02859: "Hospital Manager",
  HAB01082: "Hospital Matron",
  HAB01084: "Hospital Porter - Health",
  HAB01085: "Hospital Storeman",
  HAB01086: "Hospital Ward Orderly",
  HAB01087: "Hostel Matron",
  HAB01088: "Hostel Warden",
  HAB01089: "Hostess",
  HAD03166: "Hotel Concierge",
  HAB01090: "Hotel Detective",
  HAB01091: "Hotel Doorman",
  HAB01092: "Hotel Maid",
  HAC02850: "Hotel Manager - Office Based",
  HAB01094: "Hotel Porter",
  HAB01095: "Hotel Proprietor",
  HAB01096: "Hotel Receptionist",
  HAB01097: "House Maid",
  HAB01098: "Housekeeper",
  HAB01110: "Houseperson or Homemaker",
  HAC02851: "Housing Association Development Manager - Including Site Visits",
  HAB01100: "Housing Inspector",
  HAC02840: "Housing Manager",
  HAB01113: "Housing Officer",
  HAD03392: "HR Administrator",
  HAD03391: "Human Resources Manager",
  HAD03388: "Hydro - Extractor Operator",
  HAC02852: "Hydrographic Engineer or Surveyor",
  HAC02860: "Hydrotherapist",
  HAC02842: "Hygienist",
  HAB01104: "Hypnotherapist",
  HAB01105: "Hypnotist",
  IAB01106: "Ice Cream Van Driver",
  IAB01110: "Illusionist",
  IAC02846: "Illustrator",
  IAD03200: "Immigration Officer - Admin only",
  IAD03201: "Immigration Officer - Otherwise",
  IAC02855: "Immunologist",
  IAB01111: "Impersonator",
  IAB01112: "Importer",
  IAB01114: "Incinerator Operator",
  IAD03171: "Independent Financial Adviser - IFA",
  IAD03173: "Industrial Chemist",
  IAC02847: "Industrial Designer",
  IAC02848: "Industrial Relations Officer",
  IAC02849: "Industrial Trainer",
  IAD03191: "Influencer",
  IAD03192: "Information Security Analyst",
  IAB01118: "Inseminator",
  IAD03182: "Inspector - Not Police",
  IAD03183: "Instructor - Aviation",
  IAD03193: "Instructor - Diving",
  IAD03184: "Instructor - Other",
  IAC02851: "Instrument Maker",
  IAC02852: "Instrument Repairer",
  IAD03181: "Insulator - Asbestos Work Included",
  IAD03198: "Insulator - No Asbestos Work",
  IAB01154: "Insurance Agent",
  IAB01155: "Insurance Assessor",
  IAB01156: "Insurance Broker",
  IAB01157: "Insurance Inspector",
  IAC02853: "Interior Designer",
  IAD03169: "Internal Auditor",
  IAD03197: "Internet Specialist",
  IAB01158: "Interpreter",
  IAC02854: "Investment Analyst",
  DAD03387: "Investment Dealer",
  IAD03194: "Investment Fund Manager",
  IAB01164: "Iron and Steel Worker",
  IAB01163: "Ironer",
  IAB01165: "Ironmonger",
  IAD03195: "IT Adviser",
  IAD03170: "IT Analyst",
  IAD03196: "IT Consultant",
  IAD03185: "IT Contractor",
  IAD03186: "IT Developer",
  CAC02720: "IT Engineer",
  IAD03199: "IT Manager - Admin only",
  IAD03187: "IT Manager - Some Manual Work",
  IAD03188: "IT Professional",
  IAD03174: "IT Programmer",
  CAC02716: "IT Sales Representative - Office Based",
  IAD03189: "IT Sales Representative - Travelling",
  CAC02718: "IT Sales Representative (Includes Travelling)",
  CAC02717: "IT Software Manager",
  IAD03190: "IT Support",
  CAC02719: "IT Systems Installer",
  CAC02715: "IT Technical Support",
  IAD03176: "IT Technician",
  IAC02856: "ITU Nurse",
  JAC02855: "Janitor",
  JAB01167: "Jetty Hand",
  JAC02856: "Jeweller",
  JAB01168: "Jewellery Enameller",
  JAB01181: "Jewellery Making and Repair",
  JAB01170: "Jewellery Mounter",
  JAB01185: "Joiner",
  JAB01173: "Joiner - Construction Industry",
  JAB01182: "Joiner - Ship Building; Ship Repair and Marine Engineering",
  JAB01175: "Jointer",
  JAB01183: "Journalist - No Overseas Travel",
  JAB01184: "Journalist - With Overseas Travel",
  JAB01178: "Judge",
  JAB01179: "Judge's Clerk",
  JAB01180: "Juggler",
  JAD03181: "Justice of the Peace",
  KAD03182: "Kebab Van Vendor",
  KAB01181: "Keeper - Zoo",
  KAC02857: "Kennel Hand",
  KAB01184: "Kerb Layer",
  KAD03183: "Key Cutter",
  KAB01196: "Keyboard Operator - Type Setting",
  KAB01186: "Kiln Attendant",
  KAB01187: "Kiln Operator",
  KAD03184: "King's Counsel",
  KAB01197: "Kitchen Fitter",
  KAB01198: "Kitchen Planner",
  KAB01192: "Kitchen Porter",
  KAC02858: "Kitchen Staff",
  KAB01194: "Knife Thrower",
  KAB01195: "Knitter",
  LAB01196: "Labeller",
  LAC02881: "Laboratory Manager - Supervisory and Some Testing",
  LAC02886: "Laboratory Staff",
  LAC02860: "Laboratory Technician",
  LAD03184: "Labourer",
  LAB01246: "Lagger",
  LAB01249: "Laminator",
  LAB01251: "Land Agent",
  LAB01252: "Land Drainage Worker",
  LAB01253: "Land Surveyor",
  LAC02885: "Landlord - Property (Including Manual Work)",
  LAC02882: "Landlord - Property (No Manual Work )",
  LAD03196: "Landscape Architect",
  LAB01254: "Landscape Gardener",
  LAB01255: "Landscape Painter",
  LAD03191: "Lathe Operator",
  LAB01259: "Launderette Assistant",
  LAB01318: "Laundry Worker",
  LAB01262: "Lavatory Attendant",
  LAC02868: "Lawyer",
  LAB01319: "Leading Firefighter",
  LAC02887: "Learning Disability Nurse",
  LAB01268: "Leather Technologist",
  LAD03199: "Leather Worker",
  LAB01269: "Lecturer",
  LAB01271: "Left Luggage Attendant",
  LAC02869: "Legal Adviser",
  LAC02870: "Legal Executive",
  LAD03185: "Legal Practice Manager",
  LAD03187: "Legal Secretary",
  LAB01321: "Lehr Operator",
  LAC02888: "Leisure Centre Manager",
  LAC02889: "Leisure Centre Worker",
  LAC02883: "Letting Agent - Property",
  LAB01275: "Librarian",
  LAC02874: "Library Assistant",
  LAD03190: "Life Coach",
  LAC02890: "Life Support Technician",
  LAC02884: "Lifeboat - Crew",
  LAB01320: "Lifeguard - Beaches",
  LAC02891: "Lifeguard - Swimming Pool",
  LAB01278: "Lift Attendant",
  LAC02876: "Lift Engineer",
  LAC02877: "Lift Erector",
  LAB01280: "Light Goods Vehicle Driver",
  LAD03188: "Lighterman",
  LAB01284: "Lighting Manager",
  LAB01285: "Lighting Technician",
  LAD03192: "Linesman",
  LAB01289: "Linesman's Mate",
  LAD03197: "Linguist",
  LAC02878: "Liquidator",
  LAB01293: "Literary Agent",
  LAC02879: "Lithographer",
  LAB01294: "Lithographic Assistant",
  LAB01295: "Lithographic Plate Grainer",
  LAB01296: "Lithographic Plate Preparer",
  LAD03198: "Livestock Dealer",
  LAD03193: "Loader",
  LAD03194: "Loader Operator",
  LAB01306: "Lobster Fisherman",
  LAB01307: "Local Government Officer",
  LAC02880: "Local Newspaper Editor",
  LAB01309: "Lock Keeper",
  LAB01311: "Locksmith",
  LAB01312: "Locomotive Driver",
  LAB01313: "Locomotive Guard",
  SAB02345: "Lollipop Person",
  LAB01315: "Loss Adjuster",
  LAB01317: "Lumberjack",
  MAB01318: "Machine Attendant",
  MAB01319: "Machine Maintenance Worker",
  MAD03248: "Machine Operator - Processing",
  MAB01575: "Machine Tool Setter - Operator",
  MAB01363: "Machinery Electrician",
  MAD03201: "Machinist",
  MAD03204: "Magazine Editor",
  MAD03207: "Magazine Illustrator",
  MAD03211: "Magazine Writer",
  MAB01367: "Magician",
  MAC02881: "Magistrate - Stipendiary",
  MAC02882: "Mail Sorter",
  MAD03198: "Maintenance Fitter",
  MAD03202: "Maintenance Manager",
  MAB01377: "Maintenance Repairer",
  MAD03216: "Maintenance Technician",
  MAD03221: "Maitre d'Hotel",
  MAB01390: "Make-up Artist",
  MAB01393: "Malt Roaster",
  MAB01394: "Maltster",
  MAB01576: "Management Consultant",
  MAD03245: "Manager - Admin only",
  MAD03246: "Manager - Heavy Manual Work",
  MAD03247: "Manager - Light Manual Work",
  MAD03222: "Manager - Offshore",
  MAD03228: "Manager - Retail",
  MAD03230: "Manager - Sales",
  MAD03241: "Managing Director - Admin or Office Based only",
  MAD03249: "Managing Director - Heavy Manual Duties",
  MAD03250: "Managing Director - Light Manual Duties",
  MAD03235: "Managing Director - Other",
  MAD03236: "Managing Director - Retail",
  MAD03237: "Managing Director - Sales Management",
  MAD03238: "Managing Director - Selling",
  MAD03239: "Manhole Maker",
  MAB01451: "Manicurist",
  MAD03197: "Marine Biologist",
  MAB01453: "Marine Engineer",
  MAB01454: "Marine Installation Fitter",
  MAB01456: "Marine Surveyor",
  MAB01459: "Market Gardener",
  MAD03226: "Market or Street Trader",
  MAC02885: "Market or Street Traders Assistant",
  MAB01461: "Market Research Analyst",
  MAB01462: "Market Research Interviewer",
  MAC02920: "Market Researcher - Office Based",
  MAC02921: "Market Researcher - Street Research",
  MAC02888: "Marketing Consultant - International",
  MAC02889: "Marketing Manager",
  MAC02910: "Marketing Research Manager - Office Based",
  MAB01580: "Marquee Erector",
  MAD03196: "Marriage Guidance Counsellor",
  MAB01464: "Martial Arts Instructor",
  MAB01465: "Mason",
  MAB01466: "Mason Bricklayer",
  MAB01467: "Mason's Labourer",
  MAB01577: "Massage Therapist",
  MAC02913: "Master of Ceremonies",
  MAB01588: "Mate; Second Hand",
  MAB01581: "Materials Planner",
  MAC02891: "Mathematician",
  MAB01478: "Mattress Maker",
  MAB01482: "Meat Cutter",
  MAB01483: "Meat Inspector",
  MAB01582: "Meat Porter",
  MAB01484: "Meat Trimmer",
  MAD03205: "Mechanic",
  AAB00135: "Mechanic - Aircraft Instrument",
  EAB00801: "Mechanic - Electronics",
  EAB00802: "Mechanic - Electronics Service",
  GAC02820: "Mechanic - Garage",
  GAB01027: "Mechanic - Gas Appliance",
  GAB01031: "Mechanic - Ground Equipment Service",
  MAD03243: "Mechanic - Oil and Natural Gas Industries",
  OAB01647: "Mechanic - Optical Instrument",
  RAB02056: "Mechanic - Rig",
  SAC01941: "Mechanic - Sewing Machine",
  MAD03213: "Mechanical Engineer",
  MAB01583: "Mechanical Fitter",
  MAB01584: "Mechanical Road Sweeper",
  MAB01585: "Mechanical Shovel Driver",
  MAB01496: "Medical Practitioner",
  MAD03214: "Medical Receptionist",
  MAD03218: "Medical Secretary",
  MAC02914: "Medical Technician",
  MAB01497: "Medium",
  MAB01589: "Member of Parliament; Politician",
  MAC02915: "Mental Health Nurse",
  MAC02896: "Messenger - Motorcycle",
  MAC02922: "Messenger - Not Motorcycle",
  MAB01587: "Metal Caster",
  MAB01586: "Metal Worker",
  MAB01503: "Metallographer",
  MAB01504: "Metallurgist",
  MAB01505: "Meteorologist",
  MAD03210: "Meter Collector",
  MAD03240: "Meter Fixer or Tester",
  MAD03219: "Meter Reader",
  MAC02916: "Microbiologist",
  MAB01515: "Microfilm Operator",
  MAC02901: "Midwife",
  MAB01516: "Milk Roundsman",
  MAB01517: "Milker",
  MAD03220: "Miller",
  MAD03223: "Milliner",
  MAC02902: "Miner",
  MAD03199: "Mineralogist",
  MAC02903: "Mini Cab Driver",
  MAB01529: "Mining Engineer",
  MAB01530: "Mining Officer",
  MAB01531: "Mining Surveyor",
  MAC02904: "Minister of Religion",
  MAB01532: "Missionary",
  MAD03244: "Mixer - Processing",
  MAD03203: "Mobile Crane Driver",
  AAB00141: "Model - Artist's",
  FAB00963: "Model - Fashion",
  MAC02919: "Model - Glamour",
  PAB01946: "Model - Photographic",
  MAC02905: "Model Maker",
  MAB01546: "Money Broker",
  MAD03242: "Mortgage Adviser",
  MAB01548: "Mortuary Attendant",
  MAC02908: "Motor Fleet Manager",
  MAC02923: "Motor Service Manager - Admin only",
  MAB01578: "Motorcycle Courier",
  MAC02911: "Motorcycle Instructor",
  MAC02912: "Motorcycle Messenger",
  MAD03227: "Motorman",
  MAD03229: "Mould Maker",
  MAD03231: "Moulder",
  MAB01564: "Mud Engineer",
  MAB01565: "Mud Logger",
  MAB01566: "Mud Man",
  MAB01568: "Museum Attendant",
  MAB01569: "Museum Curator",
  MAB01570: "Museum Guide",
  MAB01579: "Music Teacher - Private",
  MAC02917: "Musical Conductor",
  MAC02918: "Musical Director",
  MAB01573: "Musical Instrument Maker",
  MAB01574: "Musical Instrument Repairer",
  MAD03206: "Musician - Professional",
  NAD03248: "Nail Technician or Beautician",
  NAC01811: "Nanny",
  NAD03247: "Nature Reserve Worker or Warden",
  NAB01575: "Navigator",
  NAC01821: "Neonatal Nurse",
  NAC01822: "Nephrologist",
  NAC01823: "Neurologist",
  NAC01824: "Neurosurgeon",
  NAB01602: "News Photographer - With Overseas Travel",
  NAB01601: "News Photographer -UK only",
  NAC01818: "Newsagent - Not Delivering Papers",
  NAC01819: "Newspaper Reporter",
  NAB01580: "Newsreader",
  NAB01581: "Newsvendor",
  NAD03241: "NHS Manager",
  NAB01587: "Nuclear Engineer",
  NAD03244: "Nuclear Plant Attendant",
  NAB01591: "Nuclear Scientist",
  NAB01592: "Nurse",
  NAB01597: "Nurse - Midwife",
  NAD03245: "Nurse - Sister",
  NAB01603: "Nurse - Teaching Duties only",
  NAD03246: "Nursery School Assistant",
  NAB01599: "Nurseryman",
  NAB01600: "Nursing Auxiliary",
  NAC01820: "Nursing Care Home Proprietor - Admin only",
  NAC01825: "Nursing Care Home Proprietor - Some Manual Duties",
  NAC01826: "Nursing Care Home Worker",
  NAC01827: "Nutritionist",
  OAC01818: "Obstetrician",
  NAC01828: "Occupational Health Nurse",
  OAB01601: "Occupational Therapist",
  OAD03247: "Oceanographer",
  OAB01644: "Office Administrator",
  OAB01605: "Office Fitter",
  OAD03383: "Office Manager",
  OAB01606: "Office Messenger",
  OAB01608: "Office Receptionist",
  OAD03384: "Official Receiver",
  OAD03251: "Off-Licence Employee",
  OAB01602: "Off-Licence Manager",
  OAB01648: "Oil Refinery Worker",
  OAD03248: "Oiler and Greaser",
  OAD03385: "Ombudsman",
  OAC08124: "Oncologist",
  OAD03386: "Online Merchandiser",
  OAD03387: "Operations Director",
  OAD03388: "Operations Manager - Admin only",
  OAC08133: "Operations Manager - Light Engineering Company",
  OAD03389: "Operations Manager - Some Manual Duties",
  OAB01616: "Operations Officer",
  OAC08125: "Ophthalmologist",
  OAB01617: "Optical Instrument Fitter",
  OAB01618: "Optical Instrument Maker",
  OAB01620: "Optical Instrument Repairer",
  OAB01621: "Optical Printer",
  OAB01622: "Optician",
  OAC01826: "Opticians Assistant",
  OAC08126: "Optometrist",
  OAC08127: "Orchestral Musician",
  OAB01625: "Orchestrator",
  OAB01628: "Orthodontic Technician",
  OAB01629: "Orthodontist",
  OAC08128: "Orthopaedic Appliance Maker",
  OAC01827: "Orthopaedic Surgeon",
  OAB01630: "Orthoptist",
  OAC08129: "Orthotic Technician",
  OAB01631: "Osteopath",
  OAD03390: "Other - Occupation Not Listed",
  OAC08130: "Otolaryngologist",
  OAD03249: "Outdoor Pursuits Centre Instructor",
  OAD03250: "Ovensman",
  OAB01637: "Overhead Crane Driver",
  OAB01638: "Overhead Linesman",
  OAB01639: "Overhead Linesman's Mate",
  OAB01643: "Oyster Fisherman",
  PAD03258: "P E Teacher",
  PAB01644: "Packaging Machine Attendant",
  PAD03261: "Packer",
  PAB01929: "Painter and Decorator (Exterior) - Including Above 40 Feet",
  PAB01930: "Painter and Decorator (Exterior) - Never Above 40 Feet",
  PAB01928: "Painter and Decorator (Interior)",
  PAD03272: "Panel Beater",
  OAB01649: "Paper and Board Manufacture Worker",
  PAB01931: "Paper Maker - Hand",
  PAB01674: "Paper Merchant",
  PAB01932: "Paramedic - Driver",
  OAC08131: "Paramedic - Helicopter",
  PAB01933: "Paramedic - No Driving",
  OAB01650: "Parcel Sorter",
  PAB01678: "Park Keeper",
  PAB01679: "Park Ranger",
  OAB01651: "Parking Enforcement Officer",
  PAB01680: "Parks Superintendent",
  PAB01681: "Parliamentary Agent",
  OAB01652: "Parts Supplier",
  PAC01832: "Party Organiser",
  OAC08132: "Passenger Liner Crew",
  PAB01944: "Passenger Liner Officer",
  PAB01685: "Pasteuriser",
  OAB01653: "Pasteurising Tank Attendant",
  PAB01687: "Patent Agent",
  PAB01688: "Pathologist",
  PAB01945: "Pattern Maker - Metal; Plastic",
  PAB01692: "Pavior",
  PAC01834: "Pawnbroker",
  PAC01879: "Pediatrician",
  PAB01693: "Pedicurist",
  PAD03388: "Performance and Quality Manager",
  PAD03259: "Personal Assistant (PA)",
  PAD03389: "Personal Protection Officer",
  PAC01880: "Personal Trainer",
  PAB01696: "Pest Control Manager",
  PAB01697: "Pest Control Operator",
  PAB01699: "Petrol Pump Attendant",
  PAC01881: "Pet-Sitter or Dog Walker",
  PAB01701: "Pharmacist",
  PAB01702: "Pharmacologist",
  PAB01703: "Pharmacy Assistant",
  PAC01844: "Phlebotomist",
  PAD03383: "Photocopier Engineer",
  PAB01704: "Photocopying Machine Operator",
  PAC01845: "Photographer",
  PAC01846: "Photographer - Aerial",
  PAB01705: "Photographic Finisher",
  PAB01707: "Photographic Mounter",
  PAC01882: "Physician - No Surgery",
  PAB01947: "Physician - Surgery",
  PAB01709: "Physicist",
  PAB01710: "Physiotherapist",
  PAB01948: "Piano or Organ Tuner",
  PAB01963: "Picker - Supermarket",
  PAB01964: "Picker - Warehouse",
  PAB01712: "Pickler",
  PAB01965: "Picture Frame Maker",
  PAC01848: "Picture Framer",
  PAB01713: "Pier Master",
  PAC01883: "Pilates Teacher",
  PAB01714: "Pile Driver",
  PAD03263: "Pipe Fitter",
  PAD03264: "Pipe Jointer",
  PAD03268: "Pipe Layer",
  PAB01949: "Pipe or Powerline Survey Work",
  PAB01731: "Pitch Melter",
  PAD03253: "Planning Engineer",
  PAB01735: "Planning Inspector",
  PAB01736: "Plant Attendant",
  PAC01884: "Plant Hire Manager - Admin only",
  PAC01873: "Plant Hire Manager - Some Manual Work",
  PAC01885: "Plant Hire Owner - Admin only",
  PAC01874: "Plant Hire Owner - Some Manual Work",
  PAC01875: "Plant Hire Proprietor - Admin only",
  PAD03254: "Plant Operator",
  PAC01887: "Plaster Cast Process Operator",
  PAB01747: "Plasterer",
  PAB01748: "Plastic Coating Operator",
  PAB01752: "Plate Cutter",
  PAB01753: "Plate Moulder",
  PAB01754: "Plate Separator",
  PAB01755: "Platelayer",
  PAB01756: "Plateman",
  PAB01950: "Plater - Aircraft or Aerospace",
  PAB01953: "Plater - Including Boiler",
  PAB01951: "Plater - Motor Vehicle and Cycle Industry",
  PAB01952: "Plater - Ship Building; Ship Repair and Marine Engineering",
  PAD03384: "Playschool or Group Worker or Leader",
  PAB01761: "Playwright",
  PAB01954: "Plumber - Construction or Industrial",
  PAC01852: "Plumber - Domestic",
  PAB01765: "Pneumatic Drill Operator",
  PAC01888: "Podiatrist",
  PAB01766: "Poet",
  PAB01767: "Pointsman",
  PAC01889: "Police Community Support Officer (PCSO)",
  PAB01956: "Police Diver",
  PAB01955: "Police Officer",
  PAD03260: "Politician",
  PAB01777: "Pollution Inspector",
  PAB01780: "Pop Musician",
  PAB01781: "Pop Singer",
  PAB01782: "Port Control Signalman",
  PAB01783: "Port Health Inspector",
  PAB01957: "Porter - Food and Drink",
  PAB01786: "Porter - Station Personnel - Railways",
  PAB01787: "Portrait Painter",
  PAB01788: "Portrait Photographer",
  PAC01853: "Postal Courier Driver",
  PAC01854: "Postal Courier Manager",
  PAB01958: "Postal Delivery Worker - No Driving",
  PAB01959: "Postal Delivery Worker - Some Driving",
  PAB01791: "Pot Fisherman",
  PAB01792: "Potman",
  PAB01793: "Potter",
  PAB01794: "Poultry Dresser",
  PAB01795: "Poultry Plucker",
  PAB01797: "Poultryman",
  PAB01798: "Power Loader Man",
  PAB01799: "Power Loader Operator",
  PAB01800: "Power Station Charge Engineer",
  PAB01801: "Power Station Manager",
  PAB01802: "Power Station Superintendent",
  PAC01857: "PR Executive",
  PAC01858: "Practice Manager",
  PAB01806: "Precision Instrument Fitter",
  PAB01807: "Precision Instrument Maker",
  PAB01808: "Precision Instrument Repairer",
  PAB01811: "Press Officer",
  PAD03396: "Press Operator - Processing",
  PAB01814: "Press Tool Setter",
  PAB01960: "Presser - Food and Drink",
  PAB01818: "Presser - Laundry",
  PAB01819: "Priest",
  PAC01890: "Primary School Teacher",
  PAB01821: "Printer",
  PAC01876: "Printing Director - Purely Admin",
  PAB01826: "Prison Officer",
  PAB01827: "Private Detective",
  PAB01831: "Probation Officer",
  PAD03397: "Process Worker",
  PAD03390: "Procurement Officer or Manager",
  PAD03385: "Producer - TV or Film or Theatre",
  PAD03391: "Product Owner",
  PAB01868: "Production Manager",
  PAB01966: "Production Superintendent",
  PAB01967: "Production Superintendent - Admin and Supervisory only",
  PAB01968: "Production Worker",
  PAC01891: "Professional Athlete",
  PAC01892: "Professional Badminton Player",
  PAC01893: "Professional Basketball Player",
  PAC01894: "Professional Billiards Player",
  PAC01895: "Professional Body Builder",
  PAC01896: "Professional Boxer",
  PAC01897: "Professional Cricketer",
  PAC01898: "Professional Darts Player",
  PAC01899: "Professional Footballer",
  PAC01900: "Professional Gambler",
  PAC01901: "Professional Gamer",
  PAC01902: "Professional Golfer",
  PAC01903: "Professional Gymnast",
  PAC01904: "Professional Hockey Player",
  PAC01905: "Professional Horserider",
  PAC01906: "Professional Ice Hockey Player",
  PAC01907: "Professional Ice Skater",
  PAC01908: "Professional Martial Artist",
  PAC01909: "Professional Motor Cycle Racer",
  PAC01910: "Professional Pool Player",
  PAC01911: "Professional Racing Driver",
  PAC01912: "Professional Road Cycle Racer",
  PAC01913: "Professional Rugby Player",
  PAC01914: "Professional Show Jumper",
  PAC01921: "Professional Snooker Player",
  PAC01915: "Professional Speedway Rider",
  PAC01865: "Professional Sportsperson",
  PAD03392: "Professor",
  PAC01866: "Project Co-ordinator",
  PAD03386: "Project Manager or Programme Manager",
  PAB01899: "Projectionist",
  PAB01900: "Prompter",
  PAD03393: "Proof Reader",
  PAB01901: "Proofer",
  PAC01877: "Property and Estate Manager",
  PAD03394: "Property Developer - Manual Work",
  PAD03387: "Property Developer - No Manual Work",
  PAB01902: "Property Manager",
  PAC01916: "Prosthetic Technician",
  PAB01906: "Psychiatrist",
  PAC01917: "Psychoanalyst",
  PAB01907: "Psychologist",
  PAC01870: "Psychotherapist",
  PAC01871: "Public Hall Bookings Office Manager",
  PAB01909: "Public Health Inspector",
  PAB01961: "Public House Manager",
  PAB01962: "Public Lighting Fitter - Erector",
  PAB01913: "Public Relations Officer",
  PAB01969: "Public Service Vehicle Driver",
  PAB01915: "Publican",
  PAB01916: "Publisher",
  PAC01918: "Pulmonologist",
  PAD03267: "Pumpman",
  PAC01919: "Pupil Support Assistant",
  PAB01923: "Puppeteer",
  PAC01878: "Purchasing Officer or Manager (not Retail)",
  PAB01924: "Purifier Man",
  PAB01925: "Purser",
  PAB01927: "Pusherman",
  PAD03395: "Pyrotechnician",
  QAD03273: "Quality Control Engineer",
  QAD03274: "Quality Control Inspector",
  QAB01930: "Quantity Surveyor",
  QAB01931: "Quarry Manager",
  QAC01874: "Quarryman",
  QAB01933: "Quartermaster",
  RAB01935: "Rabbi",
  RAD03278: "Racetrack Steward",
  RAB02047: "Radar Controller or Operator",
  RAB01937: "Radar Observer",
  RAC01877: "Radio and TV Repairer",
  RAB02048: "Radio or Radar Operator",
  RAC01907: "Radio or TV Announcer or Presenter",
  RAC01908: "Radio or TV Director or Producer",
  RAB01942: "Radio Station Manager",
  RAB02049: "Radiographer",
  RAB01948: "Radiologist",
  RAD03281: "Radiotherapist",
  RAB02050: "Rag and Bone Dealer",
  RAB02066: "Railway Engineer",
  RAB02067: "Railway Guard",
  RAB01959: "Receptionist",
  RAC01881: "Record Producer - Entertainment Industry",
  RAB01960: "Recording Engineer",
  RAD03275: "Recruitment Consultant",
  RAB01961: "Rector",
  RAC01916: "Recycling Operative",
  RAB01963: "Reflexologist",
  RAB02068: "Refrigeration Engineer",
  RAC01882: "Refuse Collector",
  RAB01964: "Registrar",
  RAC01883: "Reinsurance Broker",
  RAD03277: "Relationship Manager",
  RAC01917: "Remedial Therapist",
  RAB02069: "Removals Worker",
  RAC01918: "Renal Physician",
  RAB01967: "Rent Collector",
  RAB02052: "Reporter/Writer (Overseas Travel)",
  RAB02051: "Reporter/Writer (UK only)",
  RAB01975: "Rescue Diver",
  RAC01909: "Research Chemist",
  RAC01910: "Research Information Officer - Office Based",
  RAC01911: "Research Projects Manager - Deals With Hazardous Substances",
  RAB01976: "Research Survey Clerk",
  RAB02053: "Researcher Media",
  RAD03386: "Re-seller - Home Based",
  RAB01979: "Reservations Clerk",
  RAB01980: "Reservoir Attendant",
  RAC01912: "Residential Care Home Proprietor - Admin only",
  RAC01913: "Residential Care Home Proprietor - Full Involvement In Caring",
  RAC01888: "Residential Care Worker",
  RAC01922: "Restaurant Proprietor - No Cooking",
  RAB02054: "Restorer - Paintings",
  RAB02055: "Restorer - Stone; Brickwork",
  RAB02070: "Retail Shop Assistant",
  RAC01894: "Retail Shop Manager",
  RAC01923: "Retail Shop Manager - Admin only",
  RAC01919: "Retained Firefighter",
  RAC01896: "Retired",
  RAC01920: "Rheumatologist",
  RAC01897: "Riding Instructor",
  RAB01985: "Rig Electrician",
  RAB01986: "Rig Maintenance Diver",
  RAB01988: "Rig Medic",
  RAB01989: "Rigger - Docks",
  RAB02057: "Rigger - Film Industry (Entertainment)",
  RAB01991: "Rigger - Gas Supply Industry",
  RAB02060: "Rigger - Industrial or Plant Machinery",
  RAB02058: "Rigger - Oil and Natural Gas Industries",
  RAB02059: "Rigger - Ship Building; Ship Repair and Marine Engineering",
  RAB01995: "Ripper",
  RAD03387: "Risk Manager",
  RAB01996: "River Inspector",
  RAD03279: "Riveter",
  RAB02008: "Road Crew Member - 'Roadie'",
  RAC01924: "Road Manager - Rock Band",
  RAB02010: "Road Marker",
  RAD03384: "Road Patrolman",
  RAB02013: "Road Safety Officer",
  RAB02061: "Road Sweeper - Hand",
  RAC01902: "Road Sweeper - Mechanical",
  RAB02016: "Road Tester - Garage Trade",
  RAB02062: "Road Tester - Motor Vehicle and Cycle Industry",
  RAD03385: "Road Worker or Labourer",
  RAB02019: "Roaster",
  RAD03388: "Robotics Engineer",
  RAB02020: "Rodent Destroyer",
  RAB02022: "Roller Blind Maker",
  RAD03276: "Rollerman",
  RAB02063: "Roofer - Including Above 40 Feet",
  RAB02064: "Roofer - Never Above 40 Feet",
  RAC01914: "Roofing Inspector - Mostly Office Based (Some Estimating)",
  RAB02071: "Rope Access Technician",
  RAB02035: "Rope Maker",
  RAB02037: "Roughneck",
  RAB02039: "Roustabout",
  RAC09121: "Roustabout Pusher - Oil and Natural Gas Industries",
  RAC01915: "Rubber and Plastics Worker",
  RAB02044: "Rubber Technologist",
  SAB02047: "Saddler",
  SAD03299: "Safety Inspector",
  SAB02048: "Safety Officer",
  SAC01961: "Safety Officer - Oil and Natural Gas Industries",
  SAD03300: "Sailing Instructor",
  SAD03305: "Salary Administrator",
  SAC01943: "Sales Adviser",
  SAC01939: "Sales and Marketing Manager",
  SAD03334: "Sales Assistant - Retail",
  SAD03312: "Sales Executive",
  SAD03317: "Sales Manager",
  SAD03319: "Sales Support Administrator",
  SAB02050: "Salter",
  SAB02051: "Salvage Diver",
  SAB02052: "Salvage Man",
  SAD03283: "Sandblaster",
  SAD03321: "Sandwich Maker",
  SAD03322: "Sandwich Shop Owner",
  SAC01940: "Satellite Aerial Fixer - Domestic only",
  SAB02056: "Saturation Tank Attendant",
  SAD03296: "Saw Doctor or Repairer or Sharpener",
  SAB02350: "Sawmill Worker",
  SAB02064: "Scaffolder",
  SAD03332: "Scaffolder - Oil and Natural Gas Industries",
  SAB02068: "Scene Shifter",
  SAB02069: "Scenery Painter",
  SAD03313: "School Assistant",
  SAC01912: "School Bursar",
  SAC01944: "School Crossing Patrol Officer",
  SAC01913: "School Inspector",
  SAC01945: "School Lunchtime Assistant",
  SAC01946: "School Teacher",
  SAD03323: "Scientist",
  SAB02351: "Scooter Delivery Rider",
  SAB02074: "Scrap Breaker",
  SAB02076: "Scrap Dealer",
  SAB02328: "Screen Maker",
  SAB02079: "Screen Printer",
  SAB02081: "Screener - Quarrying",
  SAB02084: "Screwman",
  SAB02085: "Script Writer",
  SAD03324: "Scrum Master",
  SAB02087: "Sculptor",
  SAB02088: "Seaman",
  SAD03307: "Secretary",
  SAD03314: "Security Consultant",
  SAB02329: "Security Guard (Premises only)",
  SAD03285: "Security Manager",
  SAB02096: "Seismologist",
  SAC01947: "Semi - Professional Sportsperson",
  SAC01948: "Senior Fire Service Officer",
  SAC01949: "Senior House Officer",
  SAB02352: "Service Electrician",
  SAB02353: "Service Engineer",
  SAD03301: "Set Designer",
  SAB02106: "Sewage Works Attendant",
  SAB02107: "Sewage Works Manager",
  SAB02108: "Sewerman",
  SAD03315: "Sewing Machinist",
  SAB02113: "Shaftsman",
  SAB02114: "Sheep Shearer",
  SAB02115: "Sheet Fixer",
  SAD03294: "Sheet Metal Worker",
  SAC01920: "Shelf Filler",
  SAC01950: "Sheltered Home Warden",
  SAB02119: "Shepherd",
  SAB02354: "Shipbuilder",
  SAB02123: "Shipping Clerk",
  SAB02121: "Ship's Broker",
  SAB02128: "Shoe Repairer",
  SAB02330: "Shoemaker",
  SAB02129: "Shop Assistant",
  SAB02133: "Shop Fitter",
  SAD03286: "Shotblaster",
  SAD03292: "Shotfirer",
  SAB02145: "Shredding Machine Operator",
  SAB02331: "Shunter - Marshalling or Goods Yard (Railways)",
  SAB02147: "Shunter - Mining",
  SAC01951: "Shutterer",
  SAD03333: "Sieve Operator - Food",
  SAD03335: "Sieve Operator - Quarry",
  SAD03336: "Sifter - Food",
  SAD03337: "Sifter - Quarry",
  SAB02332: "Sign Writer - Including Above 40 Feet",
  SAB02333: "Sign Writer - Never Above 40 Feet",
  SAB02163: "Signalman",
  SAC01952: "Signmaker",
  SAD03287: "Siloman",
  SAB02361: "Siloman - Docks",
  SAB02362: "Siloman - Quarry",
  SAC01922: "Silversmith",
  SAD03325: "Singer",
  SAB02334: "Sister - Hospital",
  SAB02172: "Site Agent",
  SAB02335: "Skiing Instructor",
  SAB02177: "Skipper",
  SAB02181: "Slate Cutter",
  SAB02182: "Slate Dresser",
  SAB02183: "Slate Splitter",
  SAB02336: "Slater - Including Above 40 Feet",
  SAB02337: "Slater - Never Above 40 Feet",
  SAB02186: "Slaughterer",
  SAB02187: "Slaughterhouse Manager",
  SAB02188: "Sleeping Car Attendant",
  SAB02189: "Sleeve Designer",
  SAB02355: "Smart Meter Fitter",
  SAB02338: "Smith - Precious Metals",
  SAB02192: "Smoker",
  SAD03326: "Social Media Entrepreneur",
  SAD03327: "Social Media Influencer",
  SAD03328: "Social Media Manager",
  SAB02197: "Social Worker",
  SAB02198: "Sociologist",
  SAD03329: "Software Developer",
  SAD03330: "Software Engineer",
  SAB02356: "Solar Energy Technician",
  SAB02357: "Solar Power Engineer",
  SAB02199: "Solderer",
  SAB02200: "Solicitor",
  SAD03331: "Solutions Architect",
  SAB02201: "Song Writer",
  SAB02202: "Sorter - Dry Cleaning",
  SAB02203: "Sorter - Laundry",
  SAB02339: "Sorter - Post Office or Telecommunications",
  SAB02340: "Sorter - Scrap Metal",
  SAD03295: "Sound Balancer",
  SAD03297: "Sound Mixer",
  SAD03303: "Sound Recordist",
  SAB02212: "Sound Technician",
  SAB02214: "Special Air Service (SAS)",
  SAB02215: "Special Boat Service (SBS)",
  SAB02217: "Special Effects Technician",
  SAB02341: "Speech and Language Therapist",
  SAB02219: "Spiderman",
  SAC01953: "Sports Coach - Amateur Sportspeople",
  SAC01954: "Sports Coach - Professional Sportspeople",
  SAB02224: "Sports Equipment Maker",
  SAB02225: "Sports Equipment Repairer",
  SAC01955: "Sports Massage Therapist",
  SAC01956: "Sports Referee",
  SAC01957: "Sports Therapist",
  SAB02226: "Spot-Welder",
  SAD03298: "Spray Painter",
  SAB02235: "Stablehand",
  SAB02236: "Staff Nurse",
  SAB02237: "Stage Doorkeeper",
  SAB02238: "Stage Hand",
  SAD03309: "Stage Manager",
  SAC01928: "Stage Technician",
  SAB02342: "Stamper - Identification Markings",
  SAD03284: "Station Manager",
  SAD03288: "Station Officer - Fire",
  SAC01929: "Stationer",
  SAB02253: "Statistician",
  SAB02343: "Steel Erector - Including Above 40 Feet",
  SAB02344: "Steel Erector - Never Above 40 Feet",
  SAB02358: "Steel Worker",
  SAB02258: "Steeplejack",
  SAB02263: "Stenographer",
  SAD03289: "Steriliser",
  SAB02267: "Stevedore",
  SAB02269: "Stitcher",
  SAB02270: "Stockbroker",
  SAB02272: "Stockroom Storeman",
  SAB02273: "Stocktaker",
  SAB02359: "Stone and Brickwork Restorer",
  SAD03290: "Stone Breaker",
  SAD03320: "Stone or Slate Polisher",
  SAB02284: "Stonemason",
  SAB02285: "Store Detective",
  SAB02286: "Storekeeper",
  SAD03304: "Storeman",
  SAC01958: "Street Food Trader",
  SAD03310: "Structural Engineer",
  SAB02298: "Student",
  SAB02346: "Stunt Person",
  SAB02305: "Submariner",
  SAB02347: "Sugar Beet Cutter or Slicer",
  SAB02307: "Sugar Boiler",
  SAB02310: "Supermarket Cashier",
  SAD03282: "Supermarket Manager",
  SAB02360: "Supermarket Staff",
  SAC01959: "Supply Teacher",
  SAC01960: "Support Worker",
  SAB02317: "Surgeon",
  SAB02318: "Surgery Nurse",
  SAB02319: "Surgery Receptionist",
  SAB02320: "Surgical Appliance Maker",
  SAC01942: "Surgical Shoemaker",
  SAB02348: "Surveyor - Oil and Natural Gas Industries (Exploration and Production)",
  SAB02349: "Surveyor - Ship Building; Ship Repair and Marine Engineering",
  SAC01937: "Swimming Instructor",
  SAB02325: "Swimming Pool Attendant",
  SAB02326: "Switchboard Operator",
  SAB02327: "Sword Swallower",
  SAD03311: "Systems Programmer",
  TAD03338: "Tailor",
  TAD03340: "Takeaway Food Shop Assistant",
  TAD03351: "Takeaway Food Shop Manager - No Serving",
  TAB02333: "Tamperman",
  TAB02334: "Tank Room Attendant",
  TAD03327: "Tanker Driver",
  TAD03330: "Tanker Filler",
  TAD03332: "Tanner",
  TAB02338: "Tarmac Layer - Construction Industry",
  TAB02462: "Tarmac Layer - Road Maintenance and Construction",
  TAD03339: "Tattoo Artist",
  TAB02340: "Tax Consultant",
  TAB02341: "Tax Inspector",
  TAB02472: "Tax Officer",
  TAC01941: "Taxi Business Administrator",
  TAC01960: "Taxi Business Proprietor - No Driving",
  TAC01965: "Taxi Controller",
  TAB02342: "Taxi Driver",
  TAB02343: "Taxidermist",
  TAD03325: "Teacher",
  TAC01944: "Teaching Assistant",
  TAC01966: "Teaching Support Assistant",
  TAB02473: "Team Leader - No Manual Work",
  TAB02474: "Team Leader - Some Manual Work",
  TAD03348: "Technician - Admin and Site Visits",
  TAD03349: "Technician - Admin only",
  TAD03350: "Technician - Heavy Manual",
  TAD03352: "	Technician - Light Manual",
  TAB02475: "Technology Repair Technician",
  TAB02476: "Telecommunication Engineer",
  TAC01945: "Telecommunication Technical Officer",
  TAB02365: "Telegraphist",
  TAC01946: "Telephone Customer Advisor",
  TAB02366: "Telephone Exchange Superintendent",
  TAB02367: "Telephone Fitter",
  TAB02368: "Telephone Operator",
  TAB02369: "Telephone Repairer",
  TAB02370: "Telephone Supervisor",
  TAC01947: "Telephone Systems Sales Director",
  TAB02371: "Telephonist",
  TAD03323: "Telesales Caller",
  TAD03324: "Telesales Manager",
  TAC01948: "Television Engineer",
  TAD03336: "Test Engineer",
  TAB02463: "Test Pilot",
  TAD03321: "Tester",
  TAC01949: "Textile Worker",
  TAB02393: "Thatcher",
  TAC01967: "Theatre Nurse",
  TAC01950: "Theatre Sound Engineer",
  TAB02398: "Ticket Inspector",
  TAB02464: "Tiler - Including Above 40 Feet",
  TAB02465: "Tiler - Never Above 40 Feet",
  TAB02466: "Timber Merchant - No Manual Work",
  TAB02405: "Timberman",
  TAC01951: "Tobacconist",
  TAB02412: "Tool Fitter",
  TAB02413: "Tool Maker",
  TAB02477: "Toolpusher",
  TAB02417: "Tour Guide",
  TAB02418: "Tour Manager",
  TAB02419: "Tower Crane Driver",
  TAB02420: "Town Planner",
  TAB02421: "Toxicologist",
  TAB02426: "Trackman",
  TAD03345: "Trade Union Official - Full Time",
  TAB02427: "Traffic Warden",
  TAB02428: "Train Crew Inspector",
  TAB02429: "Train Crew Supervisor",
  TAC01953: "Train Driver",
  TAD03343: "Trainer - Education or Office Based",
  TAD03344: "Tram Driver or Conductor",
  TAB02432: "Translator",
  TAC01961: "Transport Company Operations Manager - Office Based",
  TAC01955: "Transport Manager",
  TAC01962: "Travel Agent - Office Based",
  TAB02434: "Travel Courier",
  TAB02435: "Trawlerman",
  TAB02436: "Tree Feller",
  TAB02437: "Tree Surgeon",
  TAB02438: "Trenchman",
  TAB02443: "Tugman",
  TAB02467: "Tunneller - No Explosives",
  TAB02468: "Tunneller - Using Explosives",
  TAC01963: "Turf Accountant - On Course",
  TAC01964: "Turf Accountant - Shop",
  TAD03347: "Turf Cutter or Layer",
  TAB02469: "Turner - Machining; Shaping (Metal Manufacture)",
  TAB02452: "Turner - Pottery Industry",
  TAB02453: "Turnstile Operator",
  TAB02470: "Tutor - Salaried",
  TAB02471: "Tutor - Self-Employed",
  TAB02457: "Type Caster",
  TAC01959: "Typesetter",
  TAB02459: "Typograph Operator",
  TAB02460: "Typographical Designer",
  TAD03342: "Tyre or Exhaust Fitter",
  UAD03343: "Umpire",
  UAB02463: "Undertaker",
  UAB02502: "Undertaker's Assistant",
  UAB02465: "Underwriter",
  UAC01960: "Unemployed",
  UAB02501: "Union Official",
  UAD03345: "University Lecturer",
  UAB02467: "Upholsterer",
  UAC01962: "Urologist",
  UAB02499: "Usher or Usherette",
  VAD03348: "Vacuum Plant Operator",
  UAB02500: "Valet or Valeter",
  VAB02471: "Valuer",
  VAD03345: "Valveman",
  VAB02498: "Van Driver",
  VAB02476: "Varnisher",
  VAB02477: "Vatman",
  VAB02478: "Vehicle Body Builder",
  VAB02479: "Vehicle Body Fitter",
  VAC01962: "Vending Machine Engineer",
  VAB02480: "Venetian Blind Maker",
  VAB02481: "Ventriloquist",
  VAD03346: "Venture Capitalist",
  VAB02482: "Verger",
  VAB02483: "Veterinarian",
  VAB02485: "Veterinary Assistant",
  VAB02497: "Veterinary Nurse",
  VAB02492: "Vicar",
  VAC01963: "Video Conference Engineer",
  VAB02493: "Video Recorder Operator",
  VAD03347: "Vintner",
  VAB02495: "Vision Mixer",
  VAD03349: "Vlogger",
  VAB02496: "Vocational Training Instructor",
  WAD03356: "Wages Clerk",
  WAB02499: "Wages Inspector",
  WAB02599: "Waiter; Waitress",
  WAB02506: "Wallpaper Printer",
  WAB02508: "Wardrobe Mistress",
  WAB02510: "Warehouse Manager",
  WAB02584: "Warehouse Operative",
  WAB02592: "Warehouse Picker",
  WAD03352: "Washer",
  WAD03362: "Waste Disposal or Recycling Operative",
  WAB02600: "Wasteman; Salvage Man",
  WAC01967: "Watch and Clock Maker",
  WAC01968: "Watch and Clock Repairer",
  WAB02585: "Watchman - Inland Waterways",
  WAB02520: "Watchstander",
  WAB02521: "Water Bailiff",
  WAB02522: "Water Infusion Man",
  WAD03361: "Water Meter Reader or Fitter or Tester",
  WAB02586: "Water Skiing - Prof Instructor",
  WAD03354: "Water Treatment Plant Operator",
  WAD03355: "Waterworks Manager",
  WAD03357: "Weaver",
  WAD03368: "Web Analyst",
  WAD03369: "Web Designer",
  WAD03365: "Web Developer",
  WAB02529: "Wedding Photographer",
  WAD03371: "Wedding Planner",
  WAB02530: "Weighbridge Clerk",
  WAD03349: "Weighbridgeman",
  WAB02587: "Weights and Measures Inspector",
  WAB02588: "Welder - Including Above 40 Feet",
  WAB02589: "Welder - Never Above 40 Feet",
  WAB02546: "Welfare Officer",
  WAB02547: "Welfare Worker",
  WAS03372: "Wellness Coach",
  WAB02556: "Wicker Worker",
  WAB02558: "Wig Maker",
  WAB02561: "Winch Operator",
  WAB02562: "Winchman",
  WAB02593: "Wind Energy Technician - Including Above 40 Feet",
  WAB02594: "Wind Energy Technician - Never Above 40 Feet",
  WAB02595: "Wind Turbine Engineer - Including Above 40 Feet",
  WAB02596: "Wind Turbine Engineer - Never Above 40 Feet",
  WAB02597: "Wind Turbine Technician - Including Above 40 Feet",
  WAB02598: "Wind Turbine Technician - Never Above 40 Feet",
  WAB02590: "Window Cleaner - Including Above 40 Feet",
  WAB02591: "Window Cleaner - Never Above 40 Feet",
  WAB02566: "Window Dresser",
  WAD03364: "Window or Conservatory Fitter",
  WAD03366: "Windscreen Fitter or Repairer",
  WAB02567: "Wire Winder",
  WAB02570: "Wood Carver",
  WAD03350: "Wood Worker",
  WAB02574: "Woodcutter",
  WAB02575: "Woodman",
  WAB02581: "Wrapping Machine Attendant",
  WAB02583: "Writer",
  XAD03362: "X-ray Technician - Radiologist",
  YAD03368: "Yacht and Boat Builder",
  YAD03365: "Yard Assistant",
  YAB02585: "Yard Cleaner",
  YAD03364: "Yarn Worker",
  YAD03366: "Yoga Teacher",
  YAC01967: "Youth Hostel Assistant and Cook",
  YAC01969: "Youth Hostel Manager - Some Manual Work",
  WAD03367: "Youth Leader - Full Time",
  YAD03369: "Youth Worker - Full Time",
  ZAD03370: "Zoo Curator",
  ZAD03385: "Zoo Director",
  ZAD03386: "Zookeeper",
  ZAD03372: "Zoological Research Associate",
  ZAD03373: "Zoological Researcher",
  ZAD03374: "Zoologist",
  ZAB02588: "Zoologist - No Overseas Field Work",
  ZAD03387: "Zumba Instructor"
};